import {createContext, useContext, useState} from 'react';
import {getGlobalListingCount} from 'api/company-list';
import {alertByError} from 'utils/alerts';
import {useMembership} from './MembershipContext';
import {get, isEqual} from 'lodash';
import {COMPANY_STATUSES} from 'configs';
import {useAuth} from './AuthContext';

const GlobalCountContext = createContext({});

function GlobalCountProvider(props) {
  const {children} = props;
  const {account} = useAuth();
  const {isSuspendedSubscription} = useMembership();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState(false);

  const isCompanySuspended = isEqual(
    get(account, 'company.company_status'),
    COMPANY_STATUSES.suspended
  );

  async function getGlobalCounts() {
    if (isSuspendedSubscription || isCompanySuspended) return;

    setIsLoading(true);
    try {
      const {data} = await getGlobalListingCount();

      setData(data);
    } catch (e) {
      alertByError(e);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <GlobalCountContext.Provider
      value={{
        getGlobalCounts,
        isGlobalCountsLoading: isLoading,
        globalCounts: data,
      }}
    >
      {children}
    </GlobalCountContext.Provider>
  );
}

const useGlobalCounts = () => useContext(GlobalCountContext);

export {GlobalCountContext, GlobalCountProvider, useGlobalCounts};
